import { createStore } from 'owa-satcheljs';
import type { WhatsNewStore } from './schema/WhatsNewStore';

export const getStore: () => WhatsNewStore = createStore<WhatsNewStore>('whatsNewStore', {
    cardStates: null,
    initSource: undefined,
});
